import { Countries } from './countries';
const countryObj = Countries;
const countryList = [];

Object.keys(countryObj).map(countryName => {
	const countryCode = countryObj[countryName];
	const countryOpt = {
		label: countryName,
		value: countryCode
	}
	if(countryObj[countryName] === "United States") {
		countryOpt.selected = "selected";
	}
	countryList.push(countryOpt);
	return countryName;
});

export default countryList;


// WEBPACK FOOTER //
// ./src/utils/countryList.js